/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupArtistsResponseArtistsInnerMembersInner
 */
export interface LookupArtistsResponseArtistsInnerMembersInner {
    /**
     * 
     * @type {string}
     * @memberof LookupArtistsResponseArtistsInnerMembersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LookupArtistsResponseArtistsInnerMembersInner
     */
    stageName: string;
}

/**
 * Check if a given object implements the LookupArtistsResponseArtistsInnerMembersInner interface.
 */
export function instanceOfLookupArtistsResponseArtistsInnerMembersInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;

    return isInstance;
}

export function LookupArtistsResponseArtistsInnerMembersInnerFromJSON(json: any): LookupArtistsResponseArtistsInnerMembersInner {
    return LookupArtistsResponseArtistsInnerMembersInnerFromJSONTyped(json, false);
}

export function LookupArtistsResponseArtistsInnerMembersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupArtistsResponseArtistsInnerMembersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageName': json['stageName'],
    };
}

export function LookupArtistsResponseArtistsInnerMembersInnerToJSON(value?: LookupArtistsResponseArtistsInnerMembersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageName': value.stageName,
    };
}

